import React, { useState } from "react";
import { Button, Container, Modal } from "react-bootstrap";
import "../../incidentes.css";
import "bootstrap/dist/css/bootstrap.min.css";

const videoBaseURL = `${process.env.REACT_APP_BUCKET}/videos/`;

const HPC = () => {
  const [show, setShow] = useState(false);
  const [videoUrl, setVideoUrl] = useState("");

  const handleShow = (url) => {
    setVideoUrl(url);
    setShow(true);
  };

  const handleClose = () => {
    setShow(false);
    setVideoUrl("");
  };

  // Estructura simplificada de los 4 videos
  const videos = [
    {
      nombre: "Video 1: ¿Qué es HPC? (Más Allá de un Servidor Rápido)",
      url: `${videoBaseURL}HPC1.mp4`,
      conceptoclave: [
        "La diferencia entre computación rápida (alta frecuencia, menos núcleos) y computación paralela(HPC: miles de núcleos trabajando juntos).",
      ],
      analogia: [
        'Un coche de Fórmula 1 (un CPU rápido) es genial para una tarea rápida. Un ejército de 1000 repartidores (HPC) es necesario para una tarea masiva (entregar 100,000 paquetes a la vez).'
      ],
      aplicacion: 'Identificar problemas "paralelizables" (simulación, renderizado, análisis de Big Data, entrenamiento de IA) que son imposibles de resolver con un solo servidor, sin importar cuán rápido sea.'
    },
    {
      nombre: "Video 2: La Arquitectura del Paralelismo: Clústeres, Nodos y GPUs",
      url: `${videoBaseURL}HPC2.mp4`,
      conceptoclave: [
        'Los bloques de construcción (Nodos) y los dos tipos principales de paralelismo: Paralelismo de Tareas (MPI/CPU) vs. Paralelismo de Datos (SIMD/GPU).',
      ],
      analogia: [
        "CPU (MPI): Una orquesta sinfónica. Tareas diferentes (violín, trombón) pero perfectamente coordinadas.\nGPU (SIMD): La ola en un estadio. La misma instrucción (levantarse) ejecutada por miles de personas (cores) sobre sus propios datos (asiento)."
      ],
      aplicacion: 'Los clústeres de CPU (orquesta) se usan para simulaciones complejas (clima, física de RF). Los clústeres de GPU (la ola) son el motor para el entrenamiento de Deep Learning y la IA.'
    },
    {
      nombre: "Video 3: Los Héroes Ocultos: La Red (Interconexión) y el Almacenamiento",
      url: `${videoBaseURL}HPC3.mp4`,
      conceptoclave: [
        'Por qué el HPC no funciona con Ethernet y NAS. La necesidad de redes de latencia ultra-baja (InfiniBand) y sistemas de archivos paralelos (Lustre).',
      ],
      analogia: [
        "Red: Ethernet/TCP son calles de ciudad (con semáforos y overhead). InfiniBand es una autopista privada de 20 carriles con comunicación directa (RDMA).\nAlmacenamiento: Un NAS es un único bibliotecario (cuello de botella). Lustre son 1000 bibliotecariossirviendo a 1000 nodos a la vez."
      ],
      aplicacion: 'InfiniBand (RDMA) es crucial para la "orquesta" (MPI). El almacenamiento paralelo es vital para alimentar los clústeres de GPU (IA) y para guardar checkpoints de simulación masivos.'
    },
    {
      nombre: 'Video 4: ¿Por Qué te Importa AHORA? HPC, Big Data y el Entrenamiento de IA',
      url: `${videoBaseURL}HPC4.mp4`,
      conceptoclave: [
        "HPC es el motor de infraestructura que hace posible la revolución moderna del Deep Learning y la GenAI.",
      ],
      analogia: [
        'Un clúster HPC (GPUs + InfiniBand) es la "planta de energía" o la "fundición industrial". No puedes construir un rascacielos (un LLM como GPT) con herramientas de garaje (una laptop).'
      ],
      aplicacion: "El entrenamiento de LLMs (un problema 100% HPC), el análisis de AIOps a escala de petabytes (usando clústeres Spark/Trino, que son HPC) y simulaciones de red 5G/6G."
    },
  ];

  return (
    <>
      <Container fluid className="background-containerr">
        <div className="text-center">
          <h1 className="mt-4">Introducción al HPC (Cómputo de Alto Desempeño)</h1>
          <hr className="linea-horizontal" />
        </div>

        <div className="table-container">
          <table className="styled-table">
            <thead>
              <tr>
                <th>#</th>
                <th>Título del Video</th>
                <th>Concepto Clave</th>
                <th>Analogía</th>
                <th>Aplicación</th>
                <th>Reproducir</th>
              </tr>
            </thead>

            <tbody>
              {videos.map((video, idx) => (
                <tr key={idx}>
                  <td>{idx + 1}</td>
                  <td><b>{video.nombre}</b></td>

                  <td>
                    <ul style={{ textAlign: "left", marginLeft: "15px" }}>
                      {video.conceptoclave.map((item, i) => (
                        <li key={i}>{item}</li>
                      ))}
                    </ul>
                  </td>

                  <td>
                    <ul style={{ textAlign: "left", marginLeft: "15px" }}>
                      {video.analogia.map((item, i) => (
                        <li key={i}>{item}</li>
                      ))}
                    </ul>
                  </td>

                  <td style={{ textAlign: "left" }}>
                    {video.aplicacion || "—"}
                  </td>

                  <td>
                    <Button
                      className="boton"
                      variant="primary"
                      onClick={() => handleShow(video.url)}
                    >
                      Reproducir Video
                    </Button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </Container>

      {/* Modal para reproducir video */}
      <Modal show={show} onHide={handleClose} size="lg" centered>
        <Modal.Header closeButton>
          <Modal.Title>Reproducción de Video</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <video width="100%" controls>
            <source src={videoUrl} type="video/mp4" />
            Tu navegador no soporta la reproducción de video.
          </video>
        </Modal.Body>
      </Modal>
    </>
  );
};

export default HPC;
